import O1HD from "../../../../engines/gameEngine";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import { WeChatPeople } from "../../manager/WeChatConst";
import backpackStallPrfab from "./backpackStallPrefab";

const {ccclass, property} = cc._decorator;

@ccclass
export default class backpackStallItem extends cc.Component {

    @property({type:cc.Node,displayName:"头像节点"})
    headNode:cc.Node = null;

    @property({type:cc.Node,displayName:"选择节点"})
    selectNode:cc.Node = null;

    @property({type:cc.Node,displayName:"勾节点"})
    gouNode:cc.Node = null;

    @property({type:cc.Label,displayName:"名字文本"})
    lbName:cc.Label = null;

    @property({type:cc.Label,displayName:"描述文本"})
    lbExplain:cc.Label = null;

    npc:WeChatPeople = null;

    stallPrefab:backpackStallPrfab = null;

    onLoad(){
        this.hideSelect();
    }

    bindData(npc:WeChatPeople,stall:backpackStallPrfab){
        this.stallPrefab = stall;
        this.npc = npc;
        this.loadItem();
    }

    async loadItem(){
        this.lbName.string = this.npc.name;
        this.lbExplain.string = this.npc.name;

        let bundle = await getOneBundle(BUNDLE_SMALL_NAME.WeChatGameBundle,true);
        bundle.load(this.npc.headUrl,cc.SpriteFrame,(err,sp:cc.SpriteFrame)=>{
            if(err){
                console.log("加载头像失败");
                return;
            }
            this.headNode.getComponent(cc.Sprite).spriteFrame = sp;
        });

    }

    setSelect(){
        this.selectNode.active = true;
        this.gouNode.active = true;
    }

    hideSelect(){
        this.selectNode.active = false;
        this.gouNode.active = false;
    }

    onBtnMe(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.stallPrefab.onSelectOnePeople(this);
    }

}
